import React from 'react'
import DataSourcePresenterDataDetails from './DataSourcePresenterDataDetails'
import FileUploadGroupBuilder from '../../../FileUploadGroupBuilder/FileUploadGroupBuilder'
import DataSourcePresenterGuidelines from './DataSourcePresenterGuidelines'

export default class DataSourcePresenterGeneral extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    if (this.props.activeTab === 'general') {
      return (
        <div>
          <DataSourcePresenterDataDetails {...this.props} />
          <div className="row">
            <div className="col-md-12">
              {!this.props.data_source.system_data ? <FileUploadGroupBuilder nested={true} read_only={true} file_upload_groups={this.props.data_source.file_upload_group ? [this.props.data_source.file_upload_group] : [{ file_uploads: [] }]} /> : null}
            </div>
          </div>
          {this.props.data_source.system_data ? <DataSourcePresenterGuidelines {...this.props}/> : null}
        </div>
      );
    } else { return null };
  };
};